import {
  getAttributeList,
  initQueryParams,
  makeDatesQueryParams,
  makeQueryParam$eq,
  makeQueryParam$null,
  makeSearchQueryParams,
} from '@/business/apiTreatment/request/queryParamsUtils';

function makeListRequest({
  limitItemsRequest,
  useEntities,
  navFullIdField = 'entity_nav_full_id',
  dateField,
  dateNullable,
  customFunc,
}) {
  return ({
    search,
    page,
    pageSize,
    entities,
    sort,
    sortBy,
    attributesObj,
    dateMin,
    dateMax,
  }) => {
    const AndQueryParams = [];
    const queryParams = initQueryParams({
      limitItemsRequest,
      pageSize,
      page,
      sort,
      sortBy,
      useEntities,
      entities,
      navFullIdField,
      AndQueryParams,
    });

    getAttributeList(attributesObj, '$eq').forEach(
      makeQueryParam$eq(attributesObj, AndQueryParams)
    );
    getAttributeList(attributesObj, '$null').forEach(
      makeQueryParam$null(attributesObj, AndQueryParams)
    );

    const orQueryParams = [];
    getAttributeList(attributesObj, 'or').forEach(
      makeQueryParam$eq(attributesObj, orQueryParams)
    );
    if (orQueryParams.length) {
      AndQueryParams.push({ $or: orQueryParams });
    }

    makeSearchQueryParams(search, AndQueryParams);
    makeDatesQueryParams(
      dateField,
      dateNullable,
      dateMin,
      AndQueryParams,
      dateMax
    );

    if (customFunc) {
      customFunc(AndQueryParams);
    }

    if (AndQueryParams.length > 0) {
      queryParams.q = {
        ...queryParams.q,
        $and: AndQueryParams,
      };
    }
    return queryParams;
  };
}

export default makeListRequest;
